// Generated by GitHub Copilot
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface DashboardUser {
  username: string;
  role: string;
}

/**
 * Session-based authentication service for the Iberdrola dashboard.
 * Uses CI4 session cookies — all requests must include credentials.
 */
@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly apiUrl = environment.apiUrl;
  private currentUser$ = new BehaviorSubject<DashboardUser | null>(null);

  constructor(private http: HttpClient) {}

  /** POST /auth/login — session cookie set by server */
  login(username: string, password: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/login`, { username, password }, { withCredentials: true }).pipe(
      // Backend returns { username, role } directly (no .user wrapper)
      tap((res: any) => this.currentUser$.next({ username: res.username, role: res.role }))
    );
  }

  /** POST /auth/logout — destroys server-side session */
  logout(): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/logout`, {}, { withCredentials: true }).pipe(
      tap(() => this.currentUser$.next(null))
    );
  }

  /** GET /auth/me — returns 401 if not authenticated */
  me(): Observable<DashboardUser> {
    return this.http.get<DashboardUser>(`${this.apiUrl}/auth/me`, { withCredentials: true }).pipe(
      tap((user) => this.currentUser$.next(user))
    );
  }

  /** Returns the current user or null without hitting the server */
  currentUser(): DashboardUser | null {
    return this.currentUser$.getValue();
  }

  /** Observable stream of the current user state */
  currentUser$asObservable(): Observable<DashboardUser | null> {
    return this.currentUser$.asObservable();
  }

  /** True if we have a local user state (may be stale — use me() for reliable check) */
  isLoggedIn(): boolean {
    return this.currentUser$.getValue() !== null;
  }
}

